import React from "react";
import {
  Flex,
  Grid,
  Heading,
  Icon,
  Image,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from "../ui/accordion";
import FooterNav from "./FooterNav";
import {
  FaXTwitter,
  FaInstagram,
  FaYoutube,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa6";

const Footer = () => {
  const quickLinks = [
    { text: "ABOUT", url: "/about" },
    { text: "SERVICES", url: "/services" },
    {
      text: "BLOG ",
      url: "https://learningwithme99.blogspot.com/",
      target: "_blank",
    },
    { text: "CONTACT", url: "/contact" },
  ];
  const message =
    "Hello, I'm interested in the [SERVICE_NAME] service. Can you provide more details?";

  const popularServices = [
    "NEW AADHAR",
    "BANNER DESIGN",
    "RESUME CREATION",
    "MARATHI TYPING",
  ].map((service) => ({
    text: service,
    url: `https://wa.me/919152832898?text=${encodeURIComponent(
      message.replace("[SERVICE_NAME]", service)
    )}`,
    target: "_blank",
  }));

  const socialmedias = [
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/heyitspetras?igsh=Y2NlM243N29pZTN6",
    },
    {
      icon: FaYoutube,
      url: "https://www.youtube.com/@learnsomethingnew3152",
    },
    {
      icon: FaFacebookF,
      url: "https://www.facebook.com/petrash.thakur.7?mibextid=ZbWKwL",
    },
    {
      icon: FaXTwitter,
      url: "https://x.com/PetrasThakur",
    },
    {
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/in/petras-thakur-9a74a0292",
    },
  ];

  return (
    <>
      <Grid
        templateColumns={{ base: "repeat( 1fr)", md: "repeat(4, 1fr )" }}
        justifyItems="center"
        justifyContent="space-between"
        bgColor="#400300"
        gap={{ base: "3", md: "0" }}
        px={{ base: "5", md: "10", lg: "20" }}
        py={10}
      >
        {/* Col 1 */}
        <Stack gap={2} direction={{ base: "row", md: "column" }}>
          <Image
            objectFit="contain"
            src="../assets/logo.png"
            alt="logo"
            w={{ base: "150px", md: "300px" }}
          />
          <Text color="white" fontSize={{ base: "xs", md: "xs", lg: "sm" }}>
            Your trusted online cyber café for seamless browsing, secure access,
            and all your digital needs, anytime, anywhere.
          </Text>
        </Stack>

        {/* Col 2 */}
        <FooterNav
          heading="POPULAR SERVICES"
          items={popularServices}
          display={{ base: "none", md: "flex" }}
        />

        {/* Col 3 */}
        <FooterNav
          heading="QUICK LINKS"
          items={quickLinks}
          display={{ base: "none", md: "flex" }}
        />

        {/* Mobile Accordion */}
        <AccordionRoot
          collapsible
          color="white"
          display={{ base: "block", md: "none" }}
        >
          <AccordionItem borderColor="gray" value="a">
            <AccordionItemTrigger>POPULAR SERVICES</AccordionItemTrigger>
            <AccordionItemContent>
              <FooterNav items={popularServices} />
            </AccordionItemContent>
          </AccordionItem>
          <AccordionItem borderColor="gray" value="b">
            <AccordionItemTrigger>QUICK LINKS</AccordionItemTrigger>
            <AccordionItemContent>
              <FooterNav items={quickLinks} />
            </AccordionItemContent>
          </AccordionItem>
        </AccordionRoot>

        {/* Col 4 */}
        <Stack alignItems="center">
          <Heading
            as="h6"
            size={{ base: "xs", md: "xs", lg: "md" }}
            pb={{ base: "0", md: "4" }}
            fontWeight="semibold"
            color="white"
          >
            CONNECT WITH US
          </Heading>

          {/* Social Icons */}
          <Flex gap={5}>
            {socialmedias.map((social) => (
              <Link href={social.url}>
                <Icon
                  color="white"
                  _hover={{ color: "wheat", transform: "scale(1.3)" }}
                  transition="transform 0.2s ease-in-out"
                  boxSize={5}
                >
                  <social.icon />
                </Icon>
              </Link>
            ))}
          </Flex>
        </Stack>
      </Grid>
    </>
  );
};

export default Footer;
